// extracted by mini-css-extract-plugin
module.exports = {"Container":"TipsHistory_Container__3HSzg","Table":"TipsHistory_Table__3ly_2","ArrowIcon":"TipsHistory_ArrowIcon__3DlzM"};